import * as React from 'react'
import { Button, useRedirect } from 'react-admin'
import LockIcon from '@mui/icons-material/Lock'
// import { Tooltip } from '@mui/material';

// NOTE!!  This code caused a browser error regarding the definition
// const TooltipWrapper = React.forwardRef(({ children, ...props }, ref) => (
//     <span ref={ref}>{React.cloneElement(children, props)}</span>
// ));

// const MyTooltip = ({ children, title, ...props }) => (
//     <Tooltip title={title} {...props}>
//         <TooltipWrapper>{children}</TooltipWrapper>
//     </Tooltip>
// );

export const LockedFeature = () => {
  const redirect = useRedirect()
  return (
    // <MyTooltip title="Unlock features by upgrading to a paid plan">
    <Button size="small" label="Upgrade" color="secondary" disabled onClick={() => redirect('/account/billing')}>
      <LockIcon />
    </Button>
    // </MyTooltip >
  )
}
